// Helper function to fire Google Analytics events via dataLayer
export function fireGoogleAnalyticsEvent(eventName, parameters = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    const eventData = {
      'event': eventName,
      ...parameters
    };
    window.dataLayer.push(eventData);
  } else {
    console.error('Google Tag Manager dataLayer not available');
  }
}
